import script from "./CreatorSupport.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorSupport.vue?vue&type=script&setup=true&lang=js"

import "./CreatorSupport.vue?vue&type=style&index=0&id=c0414024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0414024"]])

export default __exports__